import { TableMenuItems } from './drawer/table-menu-items';

const TextMenuItems = require('./drawer/text-menu-items');

module.exports = Backbone.View.extend({
  initialize: function ($elem, buttonSelect, popupMenuCommonFunctions, defaultMenus, fontMenu) {
    this.$elem = $elem;
    this.popupMenuCommonFunctions = popupMenuCommonFunctions;
    this.buttonSelect = buttonSelect;
    this.defaultMenus = defaultMenus;
    this.fontMenu = fontMenu;
  },

  drawDefaultMenuItems: function (menuId) {
    let buttons = this.defaultMenus.DEFAULT;

    if (menuId === 'link') {
      buttons = buttons.filter(item => !['STROKE', 'STROKE_COLOR', 'FILL_COLOR'].includes(item));
    }

    this.$elem.popupmenu({
      buttons,
      disableBuild: true
    });

    if ($.inArray(menuId, ['ellipse', 'rect', 'polygon', 'path', 'square', 'circle', 'misc']) === -1) {
      const menu = this.$elem.popupmenu('li', 'on_imageBox');
      menu && menu.hide();
    }

    this.$elem.popupmenu('build');
  },

  drawMultiselectMenuItems: function () {
    this.$elem.popupmenu({ buttons: this.defaultMenus.MULTISELECT });
  },

  drawGroupMenuItems: function () {
    this.$elem.popupmenu({ buttons: this.defaultMenus.GROUP });
  },

  drawLayoutMenuItems: function () {
    this.$elem.data('popupmenu') && this.$elem.removeData('popupmenu');
    this.$elem.popupmenu({ buttons: this.defaultMenus.LAYOUT });
    this.$elem.popupmenu('menu').parent().find('.back-menu').hide();

    if (this.$elem.is('image')) {
      const label = this.getRepositioningLabel();
      const $repositioningElement = '<li class="double">' +
        '<a class="btn btn-onmenu action ui-dropdown" style="cursor: default">' +
          '<span class="ui-dropdown-title">' +
            INKIVE.TranslateHelper.translate(label) +
          '</span>' +
        '</a>' +
      '</li>';

      this.$elem.popupmenu('menu').parent().filter('.special-buttons').find('ul').append($repositioningElement);
    }

    const specificButtonsContainer = this.$elem.popupmenu('menu').parent().filter('.specific-buttons')[0];
    const specificButtons = specificButtonsContainer?.querySelector('ul');

    if (!specificButtons) return;
    specificButtons.style.justifyContent = 'center';
    specificButtons.style.width = '100%';
  },

  getRepositioningLabel: function () {
    const element = this.$elem[0];
    const type = INKIVE.EditorFacade.getType(element);
    const elementId = type === 'imageclipper' ? element.dataset.oldId || element.id : element.id;
    const data = INKIVE.DesignFacade.get(elementId);
    const imageType = element.classList.contains('background') ? 'background' : 'image';
    const labelType = data && data.type === 'video' ? 'video' : imageType;

    return 'popupmenu.dropdown_title.repositioning_' + labelType;
  },

  drawLockedMenuItems: function () {
    const isLocked = localStorage.getItem('lock_elements') === 'true';
    const $popupMenu = $('#element-popupmenu');
    const $repositioningElement = '<ul><li class="double">' +
      '<a class="btn btn-onmenu action ui-dropdown locked-page">' +
          INKIVE.TranslateHelper.translate('top_submenu.file.locked_page') +
      '</a>' +
    '</li></ul>';

    const $rootButtons = $popupMenu.find('.root-popupmenu');

    $rootButtons.find('ul').toggleClass('hidden', isLocked);
    $rootButtons.find('.special-buttons').html(isLocked ? $repositioningElement : '');
  },

  drawBackgroundMenuItems: function () {
    this.$elem.popupmenu({ buttons: this.defaultMenus.BACKGROUND });
    INKIVE.DesignFacade.get('background').source || this.$elem.popupmenu('li', 'on_transform').hide();
  },

  drawImageMenuItems: function () {
    this.$elem.popupmenu({ buttons: this.defaultMenus.IMAGE });
  },

  drawLogoMenuItems: function () {
    this.$elem.popupmenu({
      buttons: this.defaultMenus.LOGO,
      disableBuild: true
    });

    this.popupMenuCommonFunctions.drawColors(this.$elem, this.buttonSelect);
    this.$elem.popupmenu('build');
  },

  drawQrcodeMenuItems: function () {
    this.drawStickerMenuItems();
  },

  drawIconMenuItems: function () {
    this.$elem.popupmenu({
      buttons: this.defaultMenus.ICON,
      disableBuild: true
    });

    this.popupMenuCommonFunctions.drawColors(this.$elem, this.buttonSelect);
    this.$elem.popupmenu('build');
  },

  drawTableMenuItems: function () {
    const tableMenu = new TableMenuItems(this.$elem, this.buttonSelect, this.popupMenuCommonFunctions, this.defaultMenus, this.fontMenu);
    const drawItems = _.bind(function () {
      tableMenu.drawTableMenuItems();
      this.popupMenuCommonFunctions.updateFontRelatedMenu(this.$elem.data('popupmenu'));
    }, this);

    INKIVE.FontsFactory.fontListLoaded && drawItems();
    INKIVE.FontsFactory.fontListLoaded || INKIVE.EditorFacade.on('fontlist.loaded', drawItems);
  },

  drawVideoMenuItems: function () {
    const xLinkHref = this.$elem.attr('xlink:href');
    const buttons = xLinkHref && xLinkHref.includes('youtube')
      ? this.defaultMenus.VIDEO_YOUTUBE
      : this.defaultMenus.VIDEO;

    this.$elem.popupmenu({ buttons });
  },

  drawStickerMenuItems: function () {
    const delayTime = 250;

    this.$elem.popupmenu({
      buttons: this.defaultMenus.STICKER,
      disableBuild: true
    });

    this.popupMenuCommonFunctions.drawColors(this.$elem, this.buttonSelect);

    const advanceMode = _.contains([
      'sticker',
      'banner',
      'placeholder'
    ], INKIVE.EditorModeManager.getMode());

    // Enable for all subelements
    setTimeout(() => {
      const hasSubelement = this.$elem.find('.textarea.subelement, .layoutBox.subelement').length > 0;

      if (advanceMode || hasSubelement) {
        $('[data-action=on_transform]').find('.ui-dropdown-content-title.on_flip, .horizontal-separator').hide();
        const onFlipH = this.$elem.popupmenu('li', 'on_flipH');
        onFlipH && onFlipH.hide();
        const onFlipV = this.$elem.popupmenu('li', 'on_flipV');
        onFlipV && onFlipV.hide();
      }
    }, delayTime);

    this.$elem.popupmenu('build');
  },

  drawTextMenuItems: function () {
    const textMenu = new TextMenuItems(this.$elem, this.buttonSelect, this.popupMenuCommonFunctions, this.defaultMenus,
      this.fontMenu);
    const drawItems = _.bind(function () {
      textMenu.drawTextMenuItems();
      this.popupMenuCommonFunctions.updateFontRelatedMenu(this.$elem.data('popupmenu'));
    }, this);

    INKIVE.FontsFactory.fontListLoaded && drawItems();
    INKIVE.FontsFactory.fontListLoaded || INKIVE.EditorFacade.on('fontlist.loaded', drawItems);
  },

  drawRootMenuItems: function (menuId) {
    this.$elem.popupmenu({ buttons: this.defaultMenus.ROOT });
    this.$elem.popupmenu('build');
  },

  drawBleedMenuItems: function (menuId) {
    this.$elem.popupmenu('destroy');
    this.$elem.popupmenu({ buttons: this.defaultMenus.BLEED });
    this.$elem.popupmenu('build');

    this.drawBleedSize();
  },

  drawBleedSize: function () {
    const editor = INKIVE.Tool.getInstance().editor;
    const canvas = editor.canvas;
    const $container = this.buttonSelect('on_bleedsize');
    const units = canvas.runExtensions('getBleedValues', {}).units;
    const list = INKIVE.TemplatesHelper(
      'popupmenu_bleed_size_list',
      getBleedSizes()
    );

    $container.find('.ui-dropdown-items').empty().append(list);
    _.bind(addBleedSizeInput, this)();

    $container.after('<span class="ui-dropdown-tag-title unit-measure">' + units + '</span>');

    function getBleedSizes () {
      let bleedSizes = [];
      const defaultSizes = {
        cm: [0, 0.3, 0.4, 0.5, 0.6],
        mm: [0, 3, 4, 5],
        in: [0, 0.125, 0.25, 0.5]
      };

      if (units === 'px') {
        for (let i = 0; i <= 100; i += 7) {
          bleedSizes.push(Math.round(i * 100) / 100);
        }
      } else {
        bleedSizes = defaultSizes[units];
      }

      return bleedSizes;
    }

    function addBleedSizeInput () {
      const editor = INKIVE.Tool.getInstance().editor;
      const canvas = editor.canvas;

      const bleed = canvas.runExtensions('getBleedValues', {});
      const bleedSize = bleed.top;

      $container.find('input').remove();
      const $items = $container.find('.ui-dropdown-items');
      const $input = $('<input name="bleed-value-set"/>');

      $input.val(bleedSize).insertBefore($items);

      $input.on('keyup', _.debounce(applySizeChanges, 500));
      $input.on('keydown', function (event) {
        if (event.which === 13) {
          event.preventDefault();
          applySizeChanges(event);
        }
      });

      function applySizeChanges () {
        const val = parseFloat($input.val());

        if (Number.isFinite(val) && val >= 0) {
          $input.val(val);
          canvas.runExtensions('modifyBleedValues', { size: val });
        }
      }
    }
  },

  drawHeaderAndFooterMenuItems: function (menuId) {
    this.$elem.popupmenu('destroy');
    this.$elem.popupmenu({ buttons: this.defaultMenus.HEADER_AND_FOOTER });
    this.$elem.popupmenu('build');
  }
});
